import * as React from 'react';
import { Container } from 'types/Watchlist';
import { formatScheduledAppointment } from 'utils/container-transforms';
import { DualCell } from './DualCell';
import { CellProps } from './types';

export const PickupAppointment: React.FC<CellProps> = (props) => {
  const container: Container = props.row;

  const scheduledAppointment = formatScheduledAppointment(container);

  return (
    <DualCell
      topText={scheduledAppointment?.value}
      bottomText="Appointment Scheduled"
      showBottomText={!!scheduledAppointment}
    />
  );
};
PickupAppointment.displayName = 'ContainerTable.PickupAppointment';
